import request from '@/utils/request'
import Vue from 'vue'

//  查询
export function getQuestionsListPage(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/personalCenter/getQuestionsListPage',
        params
    })
}
// 专家回答
export function expertAnsweringQuestion(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/expertAnsweringQuestion',
        data
    })
}
//回复框详情列表
export function getQaInfoList(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/personalCenter/getQaInfoList',
        params
    })
}
//我的申请
export function getApplyLoanListPage(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/personalCenter/getApplyLoanListPage',
        params
    })
}